export default "__VITE_ASSET__BhVH1weR__"